const NoPage = ({type}) => {

  return <div className="loading-bar"></div>;

  };
  
  export default NoPage;